<template>
  <div class="autocomplete-container">
    <vue-bootstrap-typeahead
      ref="autocompleteRef"
      v-model="query"
      :placeholder="selected.description"
      :data="results"
      :serializer="s => s.description"
      size='sm'
      @hit="selected = $event"
      :prepend="prepend"
      inputClass='input-autocomplete'
      :minMatchingChars="1"
      :skipMatchFilter="true"
    >
      <template slot="append">
        <button @click="loadMap" class="btn btn-primary">
          <font-awesome-icon icon="map-marked-alt" />
        </button>
      </template>
    </vue-bootstrap-typeahead>
    <GmapMap
      v-if="openMap"
      :center="center"
      :zoom="14"
      class="map-container"
      @click="moveMarker"
    >
      <GmapMarker
        :position="marker"
      />
    </GmapMap>

  </div>
</template>
<script>

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {_} from 'vue-underscore';
import { mapActions, mapState } from 'vuex';
import GmapMap from 'vue2-google-maps'

const defaultLat = 21.156835082887277;
const defaultLng = -86.81454786358057;
export default {
  name: 'AutoComplete',
  components: {
    VueBootstrapTypeahead,
  },
  props: {
    prepend: String,
    placeType: String
  },
  data: () => {
    return {
      query: '',
      results: [],
      openMap: false,
      center: {lat: defaultLat, lng: defaultLng},
      marker: {
        lat: defaultLat, lng: defaultLng
      }
    }
  },
  methods: {
    getAutocomplete(query) {
      const params = {
        input: query,
        components: "country:mx",
        strictbounds: true,
        types: "establishment",
        location: "21.041529751963346,-86.87519783236007",
        radius: 312922.71,
      };
      var sessionToken = this.placeType === 'from' ? this.fromPlace.googleApiSessionToken : this.toPlace.googleApiSessionToken;
      this.$http.get(process.env.VUE_APP_BT_API_AUTOCOMPLETE, {
        params: {
          params: JSON.stringify(params),
          sessionToken
        }
      }).then(res => {
          this.results = (res.body.predictions || []).filter((r) => {
            // exclude airport if the other place is already airport...
            let other = this.placeType === 'from' ? this.toPlace : this.fromPlace;
            if ((other.placeId === this.defaultPlaceId ) &&
              (r.place_id === this.defaultPlaceId)
            ) {
              return false;
            }
            return true;
          }).sort((a, b) => {
            // this work, but vue-autocomplete apply custom sort :(
            let aId = a.place_id === this.defaultPlaceId ? 0 : 1;
            let bId = b.place_id === this.defaultPlaceId ? 0 : 1;
            return aId - bId;
          });
          //window.scrollTo(0,document.body.scrollHeight);
      });
    },
    moveMarker(data) {
      this.marker.lat = data.latLng.lat();
      this.marker.lng = data.latLng.lng();
      this.$http
        .get('https://maps.googleapis.com/maps/api/geocode/json',{
          params: {
            latlng: `${this.marker.lat}, ${this.marker.lng}`,
            key: process.env.VUE_APP_GMAPS_KEY
          }
        }).then((res) => {
          if (res.body.results && res.body.results.length > 0) {
            const first = res.body.results[0];
            //show placeholder
            this.$refs.autocompleteRef.inputValue = undefined;
            this.$store.commit('placeByType', {
              id: first.place_id,
              placeType: this.placeType,
              description: first.formatted_address
            });
          }
        });
    },
    loadMap() {
      if (this.openMap) {
        this.openMap = false;
        return;
      }
      this.openMap = true;
      this.loadMarker();
    },
    loadMarker() {
      if (this.selected && this.selected.placeId && this.selected.placeId !== this.defaultPlaceId ) {
        this.$http
          .get('places', {params: {place_id: this.selected.placeId}})
          .then((res) => {
            if (res.body && res.body.result) {
              const geo = res.body.result.geometry.location;
              this.marker.lat = geo.lat;
              this.marker.lng = geo.lng;
              this.center.lat = geo.lat;
              this.center.lng = geo.lng;
            }
          });
      } else {
        this.$refs.autocompleteRef.inputValue = undefined;
        this.$store.commit('placeByType', {
          id: 'ChIJyQ6BHVMpTI8REojG9RH3GGY',
          placeType: this.placeType,
          description: 'Blvd. Kukulcan, Zona Hotelera, 77500 Cancún, Q.R., México'
        });
      }
    }
  },
  computed: {
    ...mapState(['fromPlace', 'toPlace', 'defaultPlaceId']),
    selected: {
      get() {
        if (this.placeType === 'from') {
          return this.fromPlace;
        } else {
          return this.toPlace;
        }
      },
      set(value) {
        this.$store.commit('placeByType', {
          id: value.place_id,
          placeType: this.placeType,
          description: value.description
        });
        if (this.openMap) {
          this.loadMarker();
        }
      }

    }
  },

  watch: {
    query: _.debounce(function(q) {
      this.getAutocomplete(q);
    }, 250)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .vbst-item{
    font-size: 13px;
    padding: .5rem;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
  }
  .vbt-autcomplete-list{
    margin-left: 0 !important;
    width: 100% !important;
    overflow: hidden;
  }
  .autocomplete-container{
    position: relative;
  }

  .map-container{
    width: 100%;
    height: 300px
  }
</style>
